import React from 'react';

import validate from '@vlabs/shared/validators';
import { Control, SettingsItemWrapper } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './SharedSubFormStyles.module.sass';

export const BasicParametersSubForm = () => {
  const { register, formState: { errors }, control, availableGroups } = useFormContext();
  const { t } = useTranslation();

  const commonStylesProps = {
    className: st.SettingItem,
    titleClassName: st.SettingItem__Title,
    contentClassName: st.SettingItem__Content,
  };

  return (
    <>
      <SettingsItemWrapper
        title={t('videoAnalytics:table_header.name')}
        {...commonStylesProps}
      >
        <Control.Input
          errors={errors}
          {...register('name', {
            maxLength: validate.maxLength(128),
            validate: validate.regex(/^[\p{L}0-9_-]+$/u),
          })}
        />
      </SettingsItemWrapper>

      <SettingsItemWrapper
        title={t('videoAnalytics:table_header.description')}
        {...commonStylesProps}
      >
        <Control.Input
          errors={errors}
          {...register('description', {
            maxLength: validate.maxLength(512),
          })}
        />
      </SettingsItemWrapper>

      <SettingsItemWrapper
        title={t('videoAnalytics:table_header.group')}
        {...commonStylesProps}
      >
        <Control.Select
          control={control}
          errors={errors}
          id="group_name"
          isClearable
          name="group_name"
          options={availableGroups}
        />
      </SettingsItemWrapper>
    </>
  );
};
